(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-volt-products]').forEach(root => {
      if (root.dataset.voltReady) return;
      root.dataset.voltReady = 'true';
      const selected = new Map();
      const dialog = root.querySelector('dialog');
      const status = root.querySelector('[data-volt-status]');
      const bar = root.querySelector('.volt-compare-bar');
      const sync = () => {
        bar.hidden = selected.size === 0;
        root.querySelector('[data-volt-count]').textContent = selected.size;
        root.querySelector('[data-volt-open]').disabled = selected.size < 2;
        root.querySelectorAll('[data-volt-compare]').forEach(button => button.setAttribute('aria-pressed', String(selected.has(button.dataset.id))));
      };
      root.addEventListener('click', event => {
        const filter = event.target.closest('[data-volt-filter]');
        if (filter) {
          let count = 0;
          root.querySelectorAll('[data-volt-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
          root.querySelectorAll('[data-volt-group]').forEach(card => {
            const visible = filter.dataset.voltFilter === 'all' || card.dataset.voltGroup === filter.dataset.voltFilter || filter.dataset.voltFilter === 'gaming';
            card.hidden = !visible;
            if (visible) count++;
          });
          root.querySelector('.volt-filter-empty').hidden = count > 0;
        }
        const compare = event.target.closest('[data-volt-compare]');
        if (compare) {
          if (selected.has(compare.dataset.id)) {
            selected.delete(compare.dataset.id);
            status.textContent = status.dataset.removedMessage;
          } else if (selected.size < 3) {
            selected.set(compare.dataset.id, { ...compare.dataset });
            status.textContent = status.dataset.addedMessage;
          } else status.textContent = status.dataset.maxMessage;
          sync();
        }
        if (event.target.closest('[data-volt-clear]')) { selected.clear(); sync(); }
        if (event.target.closest('[data-volt-close]')) dialog.close();
        if (event.target.closest('[data-volt-open]') && selected.size >= 2) {
          dialog.querySelectorAll('td, thead th[data-volt-column]').forEach(cell => cell.remove());
          selected.forEach(product => {
            const th = document.createElement('th');
            th.scope = 'col';
            th.dataset.voltColumn = '';
            th.textContent = product.title;
            dialog.querySelector('thead tr').append(th);
            ['image', 'price', 'stock'].forEach(key => {
              const td = document.createElement('td');
              if (key === 'image') {
                const link = document.createElement('a'); link.href = product.url;
                if (product.image) { const img = document.createElement('img'); img.src = product.image; img.alt = product.title; img.width = 160; img.height = 160; link.append(img); }
                else link.textContent = product.title;
                td.append(link);
              } else td.textContent = product[key];
              dialog.querySelector(`[data-volt-row="${key}"]`).append(td);
            });
          });
          dialog.showModal();
        }
      });
      dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
